<template>
  <layout>
    <span slot="header">{{ title }}<button class="btn-pop-close delete" aria-label="close" @click="closeModal"></button></span>
    <div slot="content">
      <div class="btn-type1">
        <el-button size="mini" type="primary" icon="el-icon-search" @click="goOpen">
          {{ this.$i18n.messages[this.$store.state.locale].search }}
        </el-button>
        <el-button size="mini" type="primary" icon="el-icon-plus" @click="save">
          자재요청
        </el-button>
      </div>
      <div class="table-area">
        <div class="table-b">
          <ag-grid-vue
              style="width: 100%; height: 320px;"
              class="ag-theme-alpine"
              :column-defs="columnDefs"
              :grid-options="gridOptions"
              :row-data="rowData"
              :default-col-def="defaultColDef"
              :statusBar="statusBar"
              :framework-components="frameworkComponent"
              :enableRangeSelection="true"
              @grid-ready="onGridReady"
              @cell-clicked="onCellClicked"
              :stopEditingWhenCellsLoseFocus="true"
              />
        </div>
      </div>
    </div>
  </layout>
</template>

<script>
import Layout from '@/components/Slot/ModalSlot.vue';
import {AgGridVue} from 'ag-grid-vue';
import MaskEditCellRenderer from "@/components/agGrid/maskedit-cell-renderer";
import CheckboxCellRenderer from "@/components/agGrid/checkbox-cell-renderer";

/**
 * Url JOIN
 */
function comma(val){
  return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
function _url(...args) {
  args = args.map(x =>
      String(x || "")
          .trim()
          .replace(/^\/*|\/*$/g, "")
  );
  return args.filter(x => x).join("/");
}


export default {
  props: {
    data: {
      Type: Array
      , required: false
    },
  },
  components: {Layout, AgGridVue},

  data() {
    return {
      title: '요청자재등록',
      form: {
        companyId : '',
        asId : '',
        asAgentId : '',
        processTime : ''
      },

      // AG-GRID OPTION [START]
      rowData:[],
      columnDefs: [],
      gridOptions: {},
      defaultColDef: {
        resizable: true,
        filter:true,
        sortable: true
      },
      frameworkComponent : {
        maskEdit: MaskEditCellRenderer,
        checkBox: CheckboxCellRenderer
      },
      statusBar: null,
      combos: {
        'requestItemType' : []
      },
    }
  },
  mounted() {
    this.form.companyId = this.$store.state.loginInfo.compCd;
    this.getCombo({flag: 'INIT'})
  },
  methods: {
    closeModal() {
      this.$parent.close();
    },
    onGridReady(){
      this.init();
      this.goOpen();
    },
    createMainColumnDefs() {
      let that = this;
      this.columnDefs = [
        {
          headerName:'선택',
          field:'chk',
          width:80,
          cellStyle : {textAlign: 'center'},
          cellRenderer: 'checkBox',
          cellRendererParams: (params) => {
            return {
              trueValue: 'Y',
              falseValue: 'N',
              disabled: params.data.itemCd === null ? false : true
            }
          }
        },
        {headerName: '구분', width: 110, field:'requestTypeNm', cellStyle:{textAlign:'center'}},
        {headerName: '제품군', width: 110, field:'itemGroupNm', cellStyle:{textAlign:'center'}},
        {headerName: '대표모델', width:160, field:'useModelNm', cellStyle:{textAlign:'left'}},
        {headerName: '품번', width:160, field:'itemCd', cellStyle:{textAlign:'left'}},
        {headerName: '품명', width:160, field:'itemNm', cellStyle:{textAlign:'left'}},
        {headerName: '규격', width:180, field:'itemSpec', cellStyle:{textAlign:'left'}},
        {headerName: '요청수량', width: 120, field:'goodQty', cellStyle:{textAlign: 'right'},
          valueFormatter: (params) => {
            return that.getNumberFormat(params.value);
          }
        },
        {headerName: '메모', width: 150, field:'memo',editable: true,
          cellStyle:{textAlign: 'left', backgroundColor: '#fff8f7'},
          valueFormatter: (params) => {
            return params.value;
          }
        }
      ];
    },
    rowDoubleClick(params){
      this.$emit('close', params.data);
    },
    onCellClicked(params) {
      //   this.$emit('close', params.data);
      //   this.closeModal();
      const idx = params.rowIndex;
      const field = params.colDef.field;
    },
    save() {
      var list = this.rowData.filter(z => z.chk === 'Y')

      if (list.length > 0) {
        let result = [];
        let saveForm = {};

        list.forEach(x => {
          saveForm = {
            productType: 'Item',
            requestType: x.requestType,
            asId : x.asId,
            requestAsAgentId: this.$store.state.loginInfo.asAgentId,
            requestUserId: this.$store.state.loginInfo.id,
            itemId: x.itemId,
            goodQty : x.goodQty,
            asAgentId: 3,
            memo: x.memo == null ? '' : x.memo
          }
          result.push(saveForm);
        })
        this.$swal({
          type: 'warning',
          text: '자재 요청을 하시겠습니까?',
          showCancelButton: true,
          confirmButtonText: '예',
          cancelButtonText: '아니요',
        }).then((response) => {
          if (response.value) {
            this.$store.commit('loading')
            this.$http.post(("/api/agent/requestMateEnter/save"), result).then(res => {
              this.$swal({ type: 'success', text: '자재를 요청하였습니다.' })
                  .then(res => {
                    if (res) {
                      this.goOpen();
                    }
                  })
            }).catch((e) => {
              this.$swal({type: 'warning', text: '자재요청에 실패 했습니다.'})
            }).finally(() => {
              this.$store.commit('finish');
            });
          }
        })
      } else {
        this.$swal({
          type: 'warning',
          text: '자재를 선택해 주십시요.'
        });
      }
    },
    async init() {
      this.$store.commit('loading');
      this.createMainColumnDefs();
      this.$store.commit('finish');
    },
    goOpen(){
      this.$store.commit('loading')
      let vForm = {
        companyId : this.form.companyId,
        asAgentId : this.$store.state.loginInfo.asAgentId,
        asId : this.form.asId,
        processTime : this.form.processTime
      }
      this.$http.post(_url("/api/agent/requestMateEnter/list"), vForm).then(response => {
        this.rowData = response.data
        /* data customize */
        this.changeData();
      }).finally(() => {
        this.$store.commit('finish')
      });
    },
    chkNumber(params, flag, excRt){
      var result = '';
      var val = params.value;
      var data = this.data;

      if(flag === 'sub') data = this.subData;

      if(!_.isEmpty(val) || _.isNumber(val)){
        val = val.toString();

        if (excRt === 'excRt') result = this.$numeral(val).format('0,0.00');
        else result = this.$numeral(val).format('0,0');
      }
      return result
    },
    getNumberFormat(val) {
      if(val){
        if(typeof val === "string"){
          val = val.replace(/[^0-9]/g, "")
        }

        return Math.floor(val).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      }
    },
    async getCombo(param) {
      if(param.flag === 'INIT'){
          this.$http.get(`/api/codeMng/detail`, { params: {parentId: 312} })  // 자재요청구분
            .then(response => {
              this.combos['requestItemType'] =  response.data;
            });
      }
    },
    /* data customize */
    changeData(){
      this.rowData.map((x, i) => {
        let filterRequestItemType = this.combos['requestItemType'].filter(y => y.catKey === x.requestType);
        x.requestTypeNm = filterRequestItemType[0].catNm;
        return x;
      })
    }

  },
  created() {
    this.form.asId = this.data.asId;
    this.statusBar = {
      statusPanels: [
        { statusPanel: 'agTotalRowCountComponent', align: 'right' },
      ],
    };
  },
}
</script>

<style lang="scss" scoped>
</style>